<template>
  <form ref="form">
    <v-container grid-list-lg class="dialog-form-full-width">
      <v-layout align-start justify-space-between nowrap row mt-1>
        <v-flex xs12 md12 lg12>
          <v-text-field
            v-model="name1"
            label="Name"
            v-validate="'required'"
            :error-messages="errors.collect('name')"
            data-vv-name="name"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="name2"
            label="Additional Name"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="name3"
            label="Additional Name"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="street"
            label="Street"
            v-validate="'required'"
            :error-messages="errors.collect('street')"
            data-vv-name="street"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="houseNumber"
            label="House number"
            v-validate="'max:' + houseNumberMaxLength"
            :error-messages="errors.collect('houseNumber')"
            data-vv-name="houseNumber"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="city"
            label="City"
            v-validate="'required'"
            :error-messages="errors.collect('city')"
            data-vv-name="city"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="postalCode"
            label="Postal Code"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="country"
            label="Country Code"
            v-validate="'required|alpha|length:2'"
            hint="ISO 3166-1 alpha-2"
            mask="AA"
            :error-messages="errors.collect('country')"
            data-vv-name="country"
            data-vv-as="country code"
            disabled
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-space-between nowrap row mt-1>
        <v-flex>
          <v-checkbox
            v-model="isOptionalOemEnabled"
            label="Allow optional OEM Segmentation"
            hide-details
            data-vv-name="isOptionalOemEnabled"
            data-vv-as="Allow optional OEM Segmentation"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-space-between nowrap row mt-1>
        <v-flex xs12 md12 lg12>
          <v-select
            v-model="clientId"
            label="Client"
            v-validate="'required'"
            :items="clients"
            :error-messages="errors.collect('clientId')"
            data-vv-name="clientId"
            data-vv-as="Client"
            item-value="id"
            item-text="label"
          ></v-select>
          <!--<v-switch
            v-model="canAddShipTo"
            color="primary"
            label="Can add ShipTo"
          ></v-switch>-->
          <v-text-field
            v-model="productHierarchyString"
            label="Product hierarchies"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-select
            v-model="customization"
            label="Configuration"
            v-validate="'required'"
            :items="customizations"
            :error-messages="errors.collect('customization')"
            data-vv-name="customization"
            data-vv-as="Configuration"
            item-value="id"
            item-text="label"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-btn @click="reset" class="ml-0">Clear</v-btn>
        <v-btn :loading="loading" @click="submit" type="submit" color="primary">
          Save
        </v-btn>
      </v-flex>
    </v-container>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },
  props: {
    customer: {
      type: Object,
      default: () => ({
        name1: "",
        name2: "",
        name3: "",
        street: "",
        houseNumber: "",
        city: "",
        postalCode: "",
        country: "",
        canAddShipTo: false,
        customization: "",
        clientId: null,
        productHierarchyString: "",
        isOptionalOemEnabled: false
      })
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editCustomer: {},
      houseNumberMaxLength: 10
    };
  },
  computed: {
    ...mapGetters("admin", {
      clients: "getClientList",
      customizations: "getCustomizationList"
    }),
    name1: {
      get() {
        return this.editCustomer.name1 || this.customer.name1;
      },
      set(value) {
        this.$set(this.editCustomer, "name1", value);
      }
    },
    name2: {
      get() {
        return this.editCustomer.name2 || this.customer.name2;
      },
      set(value) {
        this.$set(this.editCustomer, "name2", value);
      }
    },
    name3: {
      get() {
        return this.editCustomer.name3 || this.customer.name3;
      },
      set(value) {
        this.$set(this.editCustomer, "name3", value);
      }
    },
    street: {
      get() {
        return this.editCustomer.street || this.customer.street;
      },
      set(value) {
        this.$set(this.editCustomer, "street", value);
      }
    },
    houseNumber: {
      get() {
        return this.editCustomer.houseNumber !== undefined
          ? this.editCustomer.houseNumber
          : this.customer.houseNumber;
      },
      set(value) {
        this.$set(this.editCustomer, "houseNumber", value);
      }
    },
    city: {
      get() {
        return this.editCustomer.city || this.customer.city;
      },
      set(value) {
        this.$set(this.editCustomer, "city", value);
      }
    },
    postalCode: {
      get() {
        return this.editCustomer.postalCode || this.customer.postalCode;
      },
      set(value) {
        this.$set(this.editCustomer, "postalCode", value);
      }
    },
    country: {
      get() {
        return this.editCustomer.country || this.customer.country;
      },
      set(value) {
        this.$set(this.editCustomer, "country", value);
      }
    },
    canAddShipTo: {
      get() {
        return this.editCustomer.canAddShipTo !== undefined
          ? this.editCustomer.canAddShipTo
          : this.customer.canAddShipTo;
      },
      set(value) {
        this.$set(this.editCustomer, "canAddShipTo", value);
      }
    },
    customization: {
      get() {
        return this.editCustomer.customization || this.customer.customization;
      },
      set(value) {
        this.$set(this.editCustomer, "customization", value);
      }
    },
    clientId: {
      get() {
        return this.editCustomer.clientId || this.customer.clientId;
      },
      set(value) {
        this.$set(this.editCustomer, "clientId", value);
      }
    },
    productHierarchyString: {
      get() {
        return this.editCustomer.productHierarchyString !== undefined
          ? this.editCustomer.productHierarchyString
          : this.customer.productHierarchyString;
      },
      set(value) {
        this.$set(this.editCustomer, "productHierarchyString", value);
      }
    },
    isOptionalOemEnabled: {
      get() {
        return this.editCustomer.isOptionalOemEnabled !== undefined
          ? this.editCustomer.isOptionalOemEnabled
          : this.customer.isOptionalOemEnabled;
      },
      set(value) {
        this.$set(this.editCustomer, "isOptionalOemEnabled", value);
      }
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
      this.$validator.reset();
      this.editCustomer = {};
    },
    submit(event) {
      event.preventDefault();
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$emit("save", {
            name1: this.name1,
            name2: this.name2,
            name3: this.name3,
            street: this.street,
            houseNumber: this.houseNumber || null,
            city: this.city,
            postalCode: this.postalCode,
            country: this.country,
            canAddShipTo: this.canAddShipTo,
            customization: this.customization,
            clientId: this.clientId,
            productHierarchies:
              this.productHierarchyString.length > 0
                ? this.productHierarchyString.split(";")
                : [],
            isOptionalOemEnabled: this.isOptionalOemEnabled
          });
        }
      });
    }
  }
};
</script>
